module.exports = __webpack_public_path__ + "static/img/jxhd-1.59a3d7a1.png";